import React, { useState, useEffect } from 'react'
//import { useMemo } from 'react'
import style from './caroussel.module.css'
import car1 from '../../../assets/caroussel/ficar1.jpg'
import car2 from '../../../assets/caroussel/ficar2.jpg'
import car3 from '../../../assets/caroussel/ficar3.jpg'
import car4 from '../../../assets/caroussel/ficar4.jpg'
import car5 from '../../../assets/caroussel/ficar5.jpg'

const CarousselCard = () => {
  const [carBackground, setCarBackground] = useState(car1)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [isAutoPlaying, setIsAutoPlaying] = useState(true)

  const carouselItems = [
    { id: 1, image: car1, title: 'Ingénierie des coûts et estimation des projets', description: ["Ingénierie des couts ( cost engeniering)",  "Analyse et évaluation des planifications"] },
    { id: 2, image: car2, title: 'Administration de gestion', description: ["Gérer les flux et les données des clients", "Optimiser le processus et évaluation des archives et de l’administration interne"] },
    { id: 3, image: car3, title: 'Appui a la fonction financière et comptable', description: ["Gestion de l’ autonomie de votre portefeuille des clients", "Garantir la production de comptabilité et justifier selon les normes applicable en vigueur", "Assistance à la modélisation financière"]},
    { id: 4, image: car4, title: 'Coaching et formation', description: ["Générer les compétences rationnelles de votre entreprise en matière d’assimilation des formations techniques."]},
    { id: 5, image: car5, title: 'Services aux entreprise', description: ["Favoriser pour vous une gestion rigoureuse et des ressources humaines adaptes au système stratégique de votre entreprise.", "Assurer une politique commerciale des entreprises et logistique hors du commun.", "A assister les entreprises dans la mise en œuvre des systèmes de gestion et dans la production de leurs informations de communication stratégique"] }
  ]

  // Dupliquer les items pour l'effet de loop infini
  const duplicatedItems = [...carouselItems, ...carouselItems, ...carouselItems]

  // Auto-play carousel
  useEffect(() => {
    if (isAutoPlaying) {
      const interval = setInterval(() => {
        setSelectedIndex((prev) => (prev + 1) % carouselItems.length)
        setCarBackground(carouselItems[(selectedIndex + 1) % carouselItems.length].image)
      }, 4000)
      return () => clearInterval(interval)
    }
  }, [isAutoPlaying, selectedIndex, carouselItems])

  const handleCardHover = (image, index) => {
    setCarBackground(image)
    setSelectedIndex(index)
    setIsAutoPlaying(false)
  }

  const handleMouseLeave = () => {
    setIsAutoPlaying(true)
  }

  const handleDotClick = (index) => {
    setSelectedIndex(index)
    setCarBackground(carouselItems[index].image)
    setIsAutoPlaying(false)
    setTimeout(() => setIsAutoPlaying(true), 3000)
  }

  return (
    <div 
      className={style.caroussellContainer} 
      style={{
        backgroundImage: carBackground ? `linear-gradient(rgba(0, 26, 51, 0.85), rgba(0, 61, 130, 0.85)), url(${carBackground})` : 'linear-gradient(to bottom, #001a33, #003d82)',
      }}
    >
      {/* Section Header */}
      <div className={style.carouselHeader}>
        <h2 className={style.carouselTitle}>Notre Expertise en  quelques images</h2>
        <p className={style.carouselSubtitle}> </p>
      </div>

      {/* Main Carousel */}
      <div className={style.caroussell}>
        <div className={style.carGroup} onMouseLeave={handleMouseLeave}>
          {duplicatedItems.map((item, index) => (
            <div 
              key={`${item.id}-${index}`}
              className={`${style.carCard} ${selectedIndex === (index % carouselItems.length) ? style.active : ''}`}
              onMouseOver={() => handleCardHover(item.image, index % carouselItems.length)}
            >
              <div className={style.cardImageWrapper}>
                <img src={item.image} alt={item.title} />
                <div className={style.cardOverlay}>
                  <div className={style.cardContent}>
                    <h3>{item.title}</h3>
                    {/**
                     * <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    <button className={style.viewBtn}>Voir le projet</button>
                     */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Dots */}
      <div className={style.dotsContainer}>
        {carouselItems.map((item, index) => (
          <button
            key={item.id}
            className={`${style.dot} ${selectedIndex === index ? style.activeDot : ''}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Aller à l'image ${index + 1}`}
          />
        ))}
      </div>

      {/* Current Info Display */}
      <div className={style.currentInfo}>
        <div className={style.infoCard}>
          <h3>{carouselItems[selectedIndex].title}</h3>
          {carouselItems[selectedIndex].description.map((descri, index) => {
            return (
              <p key={index} > {`${index+1}. ${descri}`}</p>
            )
          })}
          <div className={style.infoMeta}>
            <span className={style.counter}>{selectedIndex + 1} / {carouselItems.length}</span>
            <button 
              className={style.playPauseBtn}
              onClick={() => setIsAutoPlaying(!isAutoPlaying)}
            >
              {isAutoPlaying ? '⏸' : '▶'}
            </button>
          </div>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button 
        className={`${style.navArrow} ${style.prevArrow}`}
        onClick={() => {
          const newIndex = selectedIndex === 0 ? carouselItems.length - 1 : selectedIndex - 1
          setSelectedIndex(newIndex)
          setCarBackground(carouselItems[newIndex].image)
          setIsAutoPlaying(false)
        }}
        aria-label="Image précédente"
      >
        ‹
      </button>
      <button 
        className={`${style.navArrow} ${style.c}`}
        onClick={() => {
          const newIndex = (selectedIndex + 1) % carouselItems.length
          setSelectedIndex(newIndex)
          setCarBackground(carouselItems[newIndex].image)
          setIsAutoPlaying(false)
        }}
        aria-label="Image suivante"
      >
        ›
      </button>
    </div>
  )
}

export default CarousselCard